export function IsSingleFile(parentDataObj) {
  var grandParent = parentDataObj.GetParent();
  while (grandParent != null) {
    var nc = grandParent.GetNumChildren();
    if (nc > 1) return false;
    grandParent = grandParent.GetParent();
  }

  return true;
}
